/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';

	/**
	 * MultiField module implementation.
	 *
	 * @author Renaldas Szentiks
	 * @namespace Tc.Module
	 * @class MultiField
	 * @extends Tc.Module
	 */
	Tc.Module.MultiField = Tc.Module.extend({

		on: function (callback) {
			this.$ctx.on('click', '.icon-close', $.proxy(this.onRemoveAction, this));
			$('.add-action', this.$ctx).on('click', $.proxy(this.onAddAction, this));
			this.$ctx.on('setValue', 'input', $.proxy(this.onSetValue, this));
			this.fieldCount = $('.multifield-container', this.$ctx).children('.inputField').length;
			this.container = $('.multifield-container', this.$ctx);
			this.fieldTemplate = this.getFieldTemplate();
			callback();
		},

		onRemoveAction: function(event) {
			var button = $(event.currentTarget),
				fieldContainer = button.parents('.inputField'),
				siblings = fieldContainer.siblings('.inputField');

			// if event was fired on the input field, delete the value
			if (button.attr('type') === 'text') {
				button.val('');
			}
			// does not allow to remove the last element
			if (siblings.length > 0) {
				fieldContainer.remove();
				if (siblings.length === 1) {
					siblings.find('.icon-close').addClass('hidden');
				}
			}
		},

		onAddAction: function() {
			var newField = this.fieldTemplate.clone(),
				inputField = newField.find('input');

			inputField.attr('id', inputField.attr('name') + '_' + this.fieldCount);
			this.fieldCount += 1;
			inputField.data('multifield', true);
			inputField.on('resetField', $.proxy(this.onRemoveAction, this));
			this.container.find('.add-action').before(newField);
			this.container.find('.icon-close').removeClass('hidden');
		},

		getFieldTemplate: function() {
			var newField = this.container.children('.inputField').first().clone(),
				inputField = newField.find('input');

			inputField.attr('id', inputField.attr('name'));
			inputField.val('');
			return newField;
		},

		onSetValue: function(event, data) {
			if (data) {
				if (data.value instanceof Array) {
					this.setRequiredNumberOfFields(data.value.length);
					$('input', this.$ctx).each(function(index){
						if (data.value.length > index) {
							$(this).val(data.value[index]);
						}
					});
				} else if (data.value) {
					this.setRequiredNumberOfFields(1);
					$('input', this.$ctx).val(data.value);
				}
			}
		},

		setRequiredNumberOfFields: function(num) {
			var difference,
				i;

			if (this.fieldCount > num && num > 1) {
				difference = this.fieldCount - num;
				for (i = 0; i < difference; i += 1) {
					$('.icon-close', this.$ctx).first().trigger('click');
				}
			} else if (this.fieldCount < num) {
				difference = num - this.fieldCount;
				for (i = 0; i < difference; i += 1) {
					this.onAddAction();
				}
			}
		}
	});
}(window.Tc.$, window.Tc));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.MultiField.js
// module id = 280
// module chunks = 0